import { getCommissionList, freshCommission, settleAgencyList } from '@/api/commission'
import { $dayFormat } from '@/utils/fn'
const state = {
  queryForm: {
    month: $dayFormat(new Date(), 2)
  },
  total: 0,
  tableData: [],
  channelTotal: 0,
  settle_money: 0
}
const getters = {
  queryForm: state => state.queryForm,
  total: state => state.total,
  tableData: state => state.tableData,
  channelTotal: state => state.channelTotal,
  settle_money: state => state.settle_money
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 佣金列表
  getCommissionList({ commit }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await getCommissionList(params)
      if (code === 200) {
        commit('save', {
          tableData: data.list,
          total: data.sum.amount,
          channelTotal: data.sum.agency_amount,
          settle_money: data.sum.settle_money
        })
        resolve()
      }
    })
  },
  // 刷新佣金列表数据
  freshCommissionFn(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await freshCommission(params)
      res.code === 200 && resolve(res)
    })
  },
  // 渠道商佣金结算列表
  settleAgencyList({ commit }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await settleAgencyList(params)
      res.code === 200 && resolve(res)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

